import enums from '../enums/RdsLife.enums';
let timeout;
class PlayerService {
  constructor(streamingUrls, player, audioPlayerStatus, stationName, stationLogo) {
    this._streamingUrls = streamingUrls;
    this._player = player;
    this._audioPlayerStatus = audioPlayerStatus;
    this._streamingUrl = '';
    this._stationName = stationName;
    this._stationLogo = stationLogo;
    this._controlsInitialized = false;
  }

  get streamingUrls() {
    return this._streamingUrls;
  }
  set streamingUrls(streamingUrls) {
    if (streamingUrls) {
      this._streamingUrls = streamingUrls;
      if (!window.cordova || window.device.platform === 'iOS') {
        if (this.player) {
          this.player.pause();
          this.player.src = this._streamingUrl = this._getRightAudio(streamingUrls);
          this.player.load();
        }
        this.status = enums.playerStatuses.PAUSED;
        this._play();
      } else {
        try {
          const vm = this;
          if (timeout) {
            clearTimeout(timeout);
          }
          vm.player.stop();

          timeout = setTimeout(() => {
            vm.player.release();
            vm.player = null;
            vm.player = new window.Media(streamingUrls[0],
              function () {
                console.log('Media Success');
              });
            vm.status = enums.playerStatuses.PAUSED;
            vm._play();
          }, 1000);
        } catch (error) {
          console.warn(error);
          // this.status = enums.playerStatuses.PAUSED;
          // this._play();
        }
        this._addBackgroundControls();
      }
    }
  }
  get player() {
    return this._player;
  }
  set player(player) {
    this._player = player;
  }
  get status() {
    return this._audioPlayerStatus;
  }
  set status(audioPlayerStatus) {
    this._audioPlayerStatus = audioPlayerStatus;
  }
  set stationName(stationName) {
    this._stationName = stationName;
  }
  get stationName() {
    return this._stationName;
  }
  set stationLogo(stationLogo) {
    this._stationLogo = stationLogo;
  }
  get stationLogo() {
    return this._stationLogo;
  }

  togglePlay() {
    if (this.status === enums.playerStatuses.PLAYING) {
      this._pause();
    } else {
      this._play();
    }
  }
  _play() {
    const sounds = this.streamingUrls;
    if (sounds) {
      if (!window.cordova || window.device.platform === 'iOS') {
        if (!this.player) {
          this.player = new Audio();
          console.log(this.player);

          const sound = this._getRightAudio(sounds);
          this.player.src = this._streamingUrl = sound;
          this.player.load();
        }
        this.player.play().then(() => { this.status = enums.playerStatuses.PLAYING; });
      } else {
        if (!this.player) {
          const vm = this;
          this.player = new window.Media(sounds[0],
            function () {
              console.log('Media Success 1');
              vm.status = enums.playerStatuses.PAUSED;
              vm._play();
            },
            // error callback
            function (err) {
              console.log('playAudio():Audio Error: ', err);
            });
        }
        this.player.play({ playAudioWhenScreenIsLocked: true });

        this.status = enums.playerStatuses.PLAYING;
      }
      if (!this._controlsInitialized) {
        this._addBackgroundControls();
        this._controlsInitialized = true;
      }
      window.MusicControls.updateIsPlaying(true);

      if (this.status !== enums.playerStatuses.PLAYING) {
        this.status = enums.playerStatuses.WAITING;
      }
    }
  }
  _pause() {
    this.player.pause();
    this.status = enums.playerStatuses.PAUSED;
    if (window.cordova && window.device.platform !== 'iOS') {
      window.MusicControls.updateIsPlaying(false);
      // document.removeEventListener('pause', _onPause, false);
    }
  }
  _getRightAudio(sounds) {
    let sound;
    if (this.player.canPlayType('audio/mpegurl')) {
      sound = sounds[0];
    } else {
      sound = sounds[1];
    }
    return sound;
  }

  _addBackgroundControls() {
    // document.addEventListener('pause', _onPause, false);
    createBackgroundControls(this.stationName, this.stationLogo);
  }

  _getAudioMimeType(filename) {
    const extension = filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
    switch (extension) {
      case 'mp3':
        return 'audio/mpeg3';
      case 'm3u8':
        return 'audio/mpegurl';
      case 'flac':
        return 'audio/flac';
      case 'm3u':
        return 'audio/mpegurl';
      case 'm4a':
        return 'audio/mp4';
      case 'm4b':
        return 'audio/mp4';
      case 'ogg':
        return 'audio/ogg';
      case 'opus':
        return 'audio/ogg';
      case 'pls':
        return 'audio/x-scpls';
      case 'wav':
        return 'audio/wav';
      default:
        return '';
    }
  }
}
const streamingUrls = [
  'https://stream.rds.radio/audio/rds.stream_aac/chunklist.m3u8',
  'https://icstream.rds.radio/rds'
];

function createBackgroundControls(stationName, logo) {
  logo = window.location.origin + logo;
  window.MusicControls.create({
    track: stationName,
    artist: '',
    album: '',
    cover: 'img/logo.png', // 'http://life.local.it:8080/img/LogoLife_3x.png',
    isPlaying: true,
    dismissable: true,
    // hide previous/next/close buttons:
    hasPrev: false,
    hasNext: false,
    hasClose: false,
    // iOS only, optional
    duration: 60, // optional, default: 0
    elapsed: 10, // optional, default: 0
    hasSkipForward: false, // optional, default: false. true value overrides hasNext.
    hasSkipBackward: false, // optional, default: false. true value overrides hasPrev.
    skipForwardInterval: 15, // optional. default: 0.
    skipBackwardInterval: 15, // optional. default: 0.
    hasScrubbing: false, // optional. default to false. Enable scrubbing from control center progress bar
    // Android only, optional
    // text displayed in the status bar when the notification (and the ticker) are updated
    // ticker: 'Now playing "Time is Running Out"',
    // All icons default to their built-in android equivalents
    // The supplied drawable name, e.g. 'media_play', is the name of a drawable found under android/res/drawable* folders
    playIcon: 'media_play',
    pauseIcon: 'media_pause',
    prevIcon: 'media_prev',
    nextIcon: 'media_next',
    closeIcon: 'media_close',
    notificationIcon: 'notification'
  }, (a, b, c) => {
    window.MusicControls.subscribe(musicControlsEvents);
    window.MusicControls.listen();
    console.log(a, b, c);
  }, (a, b, c) => { console.log(a, b, c); });
}

function musicControlsEvents(action) {
  const message = JSON.parse(action).message;
  switch (message) {
    case 'music-controls-next':
      // Do something
      break;
    case 'music-controls-previous':
      // Do something
      break;
    case 'music-controls-pause':
      playerService._pause();
      break;
    case 'music-controls-play':
      playerService._play();
      break;
    case 'music-controls-destroy':
      playerService._pause();
      window.MusicControls.destroy((a, b, c) => {
        console.log(a, b, c);
        this._controlsInitialized = false;
      }, (a, b, c) => { console.log(a, b, c); });
      break;

    // External controls (iOS only)
    case 'music-controls-toggle-play-pause':
      // Do something
      break;
    case 'music-controls-seek-to':
      const seekToInSeconds = JSON.parse(action).position;
      window.MusicControls.updateElapsed({
        elapsed: seekToInSeconds,
        isPlaying: true
      });
      // Do something
      break;

    // Headset events (Android only)
    // All media button events are listed below
    case 'music-controls-media-button':
      // Do something
      break;
    case 'music-controls-headset-unplugged':
      // Do something
      break;
    case 'music-controls-headset-plugged':
      // Do something
      break;
    default:
      break;
  }
}
const playerService = new PlayerService(streamingUrls, null, enums.playerStatuses.PAUSED, 'RDS 100% grandi successi', require('../assets/images/Logo.png'));
export default playerService;
